export default __webpack_public_path__ + "static/media/downloadIcon.73dbd4fe.svg";